(function() {
  var __snippets__ = {};
  (function() {
    var element = document.getElementById("snippets-script");
    var attribute = element ? element.getAttribute("data-snippets") : '';
    var snippets = attribute.split(",").filter(Boolean);

    for (var i = 0; i < snippets.length; i++) {
      __snippets__[snippets[i]] = true;
    }
  })();
  (function() {
  if (!__snippets__["bm-cart-drawer"] && !Shopify.designMode) return;
  try {
    (() => {
    const drawer = document.querySelector('[data-bm-cart-drawer]');

    if (!drawer) {
      return;
    }

    const itemsContainer = drawer.querySelector('[data-bm-cart-items]');
    const countElement = drawer.querySelector('[data-bm-cart-count]');
    const subtotalElement = drawer.querySelector('[data-bm-cart-subtotal]');
    const shippingText = drawer.querySelector('[data-bm-cart-shipping-text]');
    const shippingProgress = drawer.querySelector('[data-bm-cart-shipping-progress]');
    const upsell = drawer.querySelector('[data-bm-cart-upsell]');
    const upsellButton = drawer.querySelector('[data-bm-cart-upsell-button]');
    const upsellImage = drawer.querySelector('[data-bm-cart-upsell-image]');
    const upsellTitle = drawer.querySelector('[data-bm-cart-upsell-title]');
    const upsellVariant = drawer.querySelector('[data-bm-cart-upsell-variant]');
    const upsellPrice = drawer.querySelector('[data-bm-cart-upsell-price]');
    const checkoutButton = drawer.querySelector('.bm-cart-drawer__checkout');
    const upsellVariantId = Number(drawer.dataset.bmCartUpsellVariantId);
    let upsellVariantPromise = null;
    let currentCart = null;
    let pendingSyncs = 0;
    let cartSyncToken = 0;
    let syncChain = Promise.resolve();
    const pendingLineSyncs = new Map();
    const isCzMarket = drawer.dataset.bmCartIsCzMarket === 'true';
    const cartCurrency = drawer.dataset.bmCartCurrency || 'EUR';
    const translations = {
      itemSingular: drawer.dataset.bmCartItemSingular || 'item',
      itemPlural: drawer.dataset.bmCartItemPlural || 'items',
      shippingUnlocked: drawer.dataset.bmCartShippingUnlocked || 'Free EU shipping unlocked',
      shippingPrompt: drawer.dataset.bmCartShippingPrompt || 'Add one more for 25% off and free shipping',
      add: drawer.dataset.bmCartAddLabel || 'Add',
      remove: drawer.dataset.bmCartRemoveLabel || 'Remove',
      decrease: drawer.dataset.bmCartDecreaseLabel || 'Decrease quantity',
      increase: drawer.dataset.bmCartIncreaseLabel || 'Increase quantity',
    };

    const escapeHTML = (value) => {
      const div = document.createElement('div');
      div.textContent = value || '';
      return div.innerHTML;
    };

    const formatMoney = (cents) =>
      new Intl.NumberFormat(document.documentElement.lang || 'en', {
        style: 'currency',
        currency: window.Shopify?.currency?.active || cartCurrency,
      }).format(cents / 100);

    const openDrawer = () => {
      drawer.classList.add('bm-cart-drawer--open');
      drawer.setAttribute('aria-hidden', 'false');
      document.documentElement.style.overflow = 'hidden';
    };

    const closeDrawer = () => {
      drawer.classList.remove('bm-cart-drawer--open');
      drawer.setAttribute('aria-hidden', 'true');
      document.documentElement.style.overflow = '';
    };

    const getCart = async () => {
      const response = await fetch('/cart.js', { headers: { Accept: 'application/json' } });
      return response.json();
    };

    const setCartPending = (isPending) => {
      if (!checkoutButton) {
        return;
      }

      if (isPending) {
        checkoutButton.setAttribute('aria-disabled', 'true');
        checkoutButton.setAttribute('tabindex', '-1');
      } else {
        checkoutButton.removeAttribute('aria-disabled');
        checkoutButton.removeAttribute('tabindex');
      }
    };

    const beginCartSync = () => {
      pendingSyncs += 1;
      setCartPending(true);
    };

    const finishCartSync = () => {
      pendingSyncs = Math.max(0, pendingSyncs - 1);
      setCartPending(pendingSyncs > 0 || pendingLineSyncs.size > 0);
    };

    const getUpsellVariant = async () => {
      if (!upsellVariantId) {
        return null;
      }

      if (!upsellVariantPromise) {
        upsellVariantPromise = fetch(`/variants/${upsellVariantId}.js`, {
          headers: { Accept: 'application/json' },
        })
          .then((response) => {
            if (!response.ok) {
              throw new Error('Unable to load upsell variant');
            }

            return response.json();
          })
          .catch(() => null);
      }

      return upsellVariantPromise;
    };

    const updateHeaderCartCount = (count) => {
      document.querySelectorAll('.bm-header__cart').forEach((cartLink) => {
        let badge = cartLink.querySelector('.bm-header__cart-count');

        if (count <= 0) {
          badge?.remove();
          return;
        }

        if (!badge) {
          badge = document.createElement('span');
          badge.className = 'bm-header__cart-count';
          cartLink.appendChild(badge);
        }

        badge.textContent = count;
      });
    };

    const updateQuantity = async (key, quantity, token) => {
      const response = await fetch('/cart/change.js', {
        method: 'POST',
        headers: { 'Content-Type': 'application/json', Accept: 'application/json' },
        body: JSON.stringify({ id: key, quantity }),
      });
      const cart = await response.json();

      if (token === cartSyncToken) {
        currentCart = cart;
        await renderCart(currentCart);
      }
    };

    const addVariant = async (variantId, quantity = 1) => {
      const token = ++cartSyncToken;
      beginCartSync();

      try {
        await fetch('/cart/add.js', {
          method: 'POST',
          headers: { 'Content-Type': 'application/json', Accept: 'application/json' },
          body: JSON.stringify({ id: variantId, quantity }),
        });

        const cart = await getCart();

        if (token === cartSyncToken) {
          currentCart = cart;
          await renderCart(currentCart);
        }
      } finally {
        finishCartSync();
      }
    };

    const scheduleQuantitySync = (key, quantity) => {
      const existingSync = pendingLineSyncs.get(key);

      if (existingSync) {
        window.clearTimeout(existingSync.timeout);
      } else {
        setCartPending(true);
      }

      const token = ++cartSyncToken;
      const timeout = window.setTimeout(async () => {
        pendingLineSyncs.delete(key);
        beginCartSync();

        syncChain = syncChain
          .then(() => updateQuantity(key, quantity, token))
          .catch(async () => {
            currentCart = await getCart();
            await renderCart(currentCart);
          })
          .finally(() => {
            finishCartSync();
          });
      }, 360);

      pendingLineSyncs.set(key, { quantity, timeout, token });
    };

    const renderCart = async (cart = null) => {
      if (!cart) {
        cart = await getCart();
      }

      currentCart = cart;
      const countLabel =
        cart.item_count === 1
          ? `1 ${translations.itemSingular}`
          : `${cart.item_count} ${translations.itemPlural}`;
      const upsellItem = cart.items.find((item) => item.variant_id === upsellVariantId);
      const referenceItem = cart.items.find((item) => item.variant_id !== upsellVariantId);

      countElement.textContent = countLabel;
      subtotalElement.textContent = formatMoney(cart.total_price);
      updateHeaderCartCount(cart.item_count);

      const shippingPercent = isCzMarket ? 100 : Math.min((cart.item_count / 2) * 100, 100);
      shippingProgress.style.width = `${shippingPercent}%`;
      shippingText.textContent =
        isCzMarket || cart.item_count >= 2
          ? translations.shippingUnlocked
          : translations.shippingPrompt;

      itemsContainer.innerHTML = cart.items
        .map(
          (item) => {
            const isUpsellItem = item.variant_id === upsellVariantId;
            const nextQuantity = isUpsellItem ? 1 : item.quantity + 1;

            return `
            <article class="bm-cart-drawer__item">
              <img src="${escapeHTML(item.image || '')}" alt="${escapeHTML(item.product_title)}">
              <div>
                <p class="bm-cart-drawer__item-title">${escapeHTML(item.product_title)}</p>
                <p class="bm-cart-drawer__item-variant">${escapeHTML(item.variant_title || '')}</p>
                <div class="bm-cart-drawer__item-actions">
                  <div class="bm-cart-drawer__quantity">
                    <button type="button" data-bm-cart-quantity="${item.quantity - 1}" data-line-key="${escapeHTML(item.key)}" aria-label="${escapeHTML(translations.decrease)}">-</button>
                    <span>${item.quantity}</span>
                    <button
                      type="button"
                      data-bm-cart-quantity="${nextQuantity}"
                      data-line-key="${escapeHTML(item.key)}"
                      aria-label="${escapeHTML(translations.increase)}"
                      ${isUpsellItem ? 'disabled aria-disabled="true"' : ''}
                    >+</button>
                  </div>
                  <button type="button" class="bm-cart-drawer__remove" data-bm-cart-remove data-line-key="${escapeHTML(item.key)}" aria-label="${escapeHTML(translations.remove)}">
                    <svg viewBox="0 0 24 24" fill="none" aria-hidden="true">
                      <path d="M6.5 7.5h11" stroke="currentColor" stroke-width="1.6" stroke-linecap="round"/>
                      <path d="M9.5 7.5V5.8c0-.8.6-1.3 1.4-1.3h2.2c.8 0 1.4.5 1.4 1.3v1.7" stroke="currentColor" stroke-width="1.6" stroke-linecap="round"/>
                      <path d="M8 10l.6 8.2c.1.8.7 1.3 1.5 1.3h3.8c.8 0 1.4-.5 1.5-1.3L16 10" stroke="currentColor" stroke-width="1.6" stroke-linecap="round"/>
                      <path d="M11 11.5v5.5M13 11.5v5.5" stroke="currentColor" stroke-width="1.6" stroke-linecap="round"/>
                    </svg>
                  </button>
                </div>
              </div>
              <p class="bm-cart-drawer__item-price">${formatMoney(item.final_line_price)}</p>
            </article>
          `;
          }
        )
        .join('');

      if (referenceItem && !upsellItem && upsellVariantId) {
        const upsellVariantData = await getUpsellVariant();
        const dynamicUpsellPrice = upsellVariantData?.price ?? Math.round(referenceItem.final_price * 0.75);

        upsell.hidden = false;
        upsellImage.innerHTML = referenceItem.image
          ? `<img src="${escapeHTML(referenceItem.image)}" alt="${escapeHTML(referenceItem.product_title)}">`
          : '';
        upsellTitle.textContent = referenceItem.product_title;
        upsellVariant.textContent = referenceItem.variant_title || '';
        upsellPrice.textContent = formatMoney(dynamicUpsellPrice);
      } else {
        upsell.hidden = true;
      }
    };

    const optimisticChangeQuantity = (key, quantity) => {
      if (!currentCart) {
        return null;
      }

      const nextCart = structuredClone(currentCart);
      const itemIndex = nextCart.items.findIndex((item) => item.key === key);

      if (itemIndex < 0) {
        return null;
      }

      const item = nextCart.items[itemIndex];
      const previousQuantity = item.quantity;
      const nextQuantity = Math.max(0, quantity);
      const quantityDelta = nextQuantity - previousQuantity;
      const linePriceDelta = item.final_price * quantityDelta;

      if (nextQuantity === 0) {
        nextCart.items.splice(itemIndex, 1);
      } else {
        item.quantity = nextQuantity;
        item.final_line_price = Math.max(0, item.final_price * nextQuantity);
        item.line_price = Math.max(0, item.price * nextQuantity);
      }

      nextCart.item_count = Math.max(0, nextCart.item_count + quantityDelta);
      nextCart.total_price = Math.max(0, nextCart.total_price + linePriceDelta);
      currentCart = nextCart;

      return nextCart;
    };

    const optimisticAddUpsell = async () => {
      if (!currentCart || !upsellVariantId) {
        return null;
      }

      const alreadyHasUpsell = currentCart.items.some((item) => item.variant_id === upsellVariantId);

      if (alreadyHasUpsell) {
        return currentCart;
      }

      const referenceItem = currentCart.items.find((item) => item.variant_id !== upsellVariantId);
      const upsellVariantData = await getUpsellVariant();

      if (!referenceItem || !upsellVariantData) {
        return null;
      }

      const nextCart = structuredClone(currentCart);
      const variantTitle = upsellVariantData.public_title || upsellVariantData.title || '';
      const itemKey = `${upsellVariantId}:optimistic`;

      nextCart.items.push({
        key: itemKey,
        variant_id: upsellVariantId,
        quantity: 1,
        final_price: upsellVariantData.price,
        price: upsellVariantData.price,
        final_line_price: upsellVariantData.price,
        line_price: upsellVariantData.price,
        image: referenceItem.image,
        product_title: referenceItem.product_title,
        variant_title: variantTitle === 'Default Title' ? '' : variantTitle,
      });
      nextCart.item_count += 1;
      nextCart.total_price += upsellVariantData.price;
      currentCart = nextCart;

      return nextCart;
    };

    document.addEventListener('click', async (event) => {
      const cartLink = event.target.closest('a[href="/cart"], a[href$="/cart"], .bm-header__cart');
      const closeButton = event.target.closest('[data-bm-cart-close]');
      const quantityButton = event.target.closest('[data-bm-cart-quantity]');
      const removeButton = event.target.closest('[data-bm-cart-remove]');
      const checkoutLink = event.target.closest('.bm-cart-drawer__checkout');

      if (checkoutLink && checkoutLink.getAttribute('aria-disabled') === 'true') {
        event.preventDefault();
        return;
      }

      if (closeButton) {
        closeDrawer();
        return;
      }

      if (cartLink) {
        event.preventDefault();
        if (currentCart) {
          await renderCart(currentCart);
        } else {
          await renderCart();
        }
        openDrawer();
        return;
      }

      if (quantityButton) {
        const key = quantityButton.dataset.lineKey;
        const quantity = Number(quantityButton.dataset.bmCartQuantity);
        const optimisticCart = optimisticChangeQuantity(key, quantity);

        if (optimisticCart) {
          await renderCart(optimisticCart);
        }

        scheduleQuantitySync(key, quantity);
        return;
      }

      if (removeButton) {
        const key = removeButton.dataset.lineKey;
        const optimisticCart = optimisticChangeQuantity(key, 0);

        if (optimisticCart) {
          await renderCart(optimisticCart);
        }

        scheduleQuantitySync(key, 0);
      }
    });

    document.addEventListener('submit', async (event) => {
      const form = event.target;

      if (!(form instanceof HTMLFormElement) || !form.action.includes('/cart/add')) {
        return;
      }

      event.preventDefault();

      await fetch('/cart/add.js', {
        method: 'POST',
        body: new FormData(form),
        headers: { Accept: 'application/json' },
      });

      currentCart = await getCart();
      await renderCart(currentCart);
      openDrawer();
    });

    upsellButton?.addEventListener('click', async () => {
      if (!upsellVariantId) {
        return;
      }

      if (!currentCart) {
        currentCart = await getCart();
      }

      const alreadyHasUpsell = currentCart.items.some((item) => item.variant_id === upsellVariantId);

      if (alreadyHasUpsell) {
        await renderCart(currentCart);
        return;
      }

      const optimisticCart = await optimisticAddUpsell();

      if (optimisticCart) {
        await renderCart(optimisticCart);
      }

      await addVariant(upsellVariantId, 1);
    });
  })();
  } catch(e) { console.error(e); }
})();

})();
